import React, {ReactNode} from 'react';

import '@mantine/core/styles.css';
import {createTheme, DEFAULT_THEME, MantineProvider} from '@mantine/core';

interface LayoutProps {
    children: ReactNode;
}

const theme = createTheme({
  fontFamily: 'Inter, sans-serif',
  fontFamilyMonospace: 'Monaco, Courier, monospace',
  headings: {
    fontFamily: `Montserrat, ${DEFAULT_THEME.fontFamily}`,
  },
});

const ApplicationProvider: React.FC<LayoutProps> = ({children}) => {
    return (
        <MantineProvider theme={theme}>
            {children}
        </MantineProvider>
    );
};

export default ApplicationProvider;